import { useTranslation } from "react-i18next";
import { Button } from "@qivia/ui";
import { Page } from "../../components/Page";
import "../../../i18n/i18n";

interface VehicleRestitutionConditionStepProps {
  onReturn: () => void;
  onValidate: () => void;
}

export const VehicleRestitutionConditionStep = (
  props: VehicleRestitutionConditionStepProps,
) => {
  const { t } = useTranslation();

  return (
    <Page
      title={t("restitution.vehicleCondition.title")}
      returnButton
      returnButtonAction={props.onReturn}
      bottomButton={
        <Button
          title={t("restitution.button.validate")}
          onClick={props.onValidate}
          height={3.5}
        />
      }
    />
  );
};
